/**
 * MobileTeacherSupplies — mobile variant of /me/supplies.
 *
 * BON-95: prep & inventory have no source yet (the inventory module —
 * BON-151), so the surface renders the design's four modules (Prep
 * Checklist, My Stock, Prep List · Next 5 workshops, Incoming Resupply) as
 * an em-dash skeleton behind a single <MockedOverlay>, mirroring the
 * desktop bucket. It lights up when the inventory module ships.
 */
import { MockedOverlay } from '../primitives';
import { BucketError, BucketLoading } from '../regional/BucketStates';
import { useTeacherSupplies } from '../teacher/teacherApi';

import MobileMockedModuleCard from './components/MobileMockedModuleCard';
import MobileSurface from './MobileSurface';

const MODULES = [
  'Prep Checklist',
  'My Stock',
  'Prep List · Next 5 workshops',
  'Incoming Resupply',
] as const;

export default function MobileTeacherSupplies() {
  const q = useTeacherSupplies();

  if (q.isLoading) {
    return (
      <MobileSurface title="My supplies" subtitle="Loading…">
        <BucketLoading />
      </MobileSurface>
    );
  }
  if (q.isError) {
    return (
      <MobileSurface title="My supplies" subtitle="Couldn’t load">
        <BucketError error={q.error} />
      </MobileSurface>
    );
  }
  if (!q.data) return null;

  return (
    <MobileSurface title="My supplies" subtitle="Prep & inventory">
      <MockedOverlay reason="Prep & inventory data isn’t wired up yet. Goes live once the inventory module ships — tracked in BON-151.">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {MODULES.map((m) => (
            <MobileMockedModuleCard key={m} title={m} />
          ))}
        </div>
      </MockedOverlay>
    </MobileSurface>
  );
}
